__turbopack_context__.v({
  "address": "DealerListingsBlok-module__lWSd-W__address",
  "blok-big-title": "DealerListingsBlok-module__lWSd-W__blok-big-title",
  "blok-subtitle": "DealerListingsBlok-module__lWSd-W__blok-subtitle",
  "blok-title": "DealerListingsBlok-module__lWSd-W__blok-title",
  "city": "DealerListingsBlok-module__lWSd-W__city",
  "clearIcon": "DealerListingsBlok-module__lWSd-W__clearIcon",
  "dealerList": "DealerListingsBlok-module__lWSd-W__dealerList",
  "dealerLocation": "DealerListingsBlok-module__lWSd-W__dealerLocation",
  "dealerTable": "DealerListingsBlok-module__lWSd-W__dealerTable",
  "dealerTitle": "DealerListingsBlok-module__lWSd-W__dealerTitle",
  "filters": "DealerListingsBlok-module__lWSd-W__filters",
  "indicator": "DealerListingsBlok-module__lWSd-W__indicator",
  "listingViewport": "DealerListingsBlok-module__lWSd-W__listingViewport",
  "searchField": "DealerListingsBlok-module__lWSd-W__searchField",
  "searchIcon": "DealerListingsBlok-module__lWSd-W__searchIcon",
  "select": "DealerListingsBlok-module__lWSd-W__select",
  "selectField": "DealerListingsBlok-module__lWSd-W__selectField",
  "selectGroup": "DealerListingsBlok-module__lWSd-W__selectGroup",
});
